/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type SeedMessageSchemaRole = typeof SeedMessageSchemaRole[keyof typeof SeedMessageSchemaRole];


export const SeedMessageSchemaRole = {
  user: 'user',
  assistant: 'assistant',
} as const;
